import { takeLatest, call, put } from "redux-saga/effects";
import {
  fetchBooksRequest,
  fetchBooksSuccess,
  fetchBooksFailure,
} from "../slices/bookSlice";
import { fetchBooksFromAPI } from "../api/bookApi";

function* fetchBooksSaga(action) {
  try {
    const books = yield call(
      fetchBooksFromAPI,
      action.payload.selectedLanguageIds
    );
    yield put(fetchBooksSuccess(books));
  } catch (error) {
    yield put(fetchBooksFailure(error.message));
  }
}

export function* watchBookSaga() {
  yield takeLatest(fetchBooksRequest.type, fetchBooksSaga);
}
